import Component from '../core/Component'
import { format, parseInteger } from '../utils/Number'
import { triggerEvent } from '../utils/dom'
import noUiSlider from 'nouislider'

export default class RangeInput extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            range: null,
            rangeFrom: null,
            rangeFromInput: null,
            rangeTo: null,
            rangeToInput: null
        }
    }

    prepare() {
        const min = parseInteger(this.ref.range.dataset.min) || 0
        const max = parseInteger(this.ref.range.dataset.max) || 10000

        if (min === max) {
            return
        }

        this.slider = noUiSlider.create(this.ref.range, {
            start: [
                parseInteger(this.ref.rangeFromInput.value),
                parseInteger(this.ref.rangeToInput.value)
            ],
            connect: true,
            range: {
                min,
                max
            }
        })

        this.slider.on('update', ([fromValue, toValue]) => {
            this.ref.rangeFromInput.value = Math.round(fromValue)
            this.ref.rangeToInput.value = Math.round(toValue)
        })

        this.slider.on('end', values => {
            const value = `${this.ref.rangeFromInput.value.trim()}${this.ref.rangeToInput.value.trim()}`
            if (this.current !== value) {
                this.current = value
                triggerEvent(this.element, 'change')
            }
        })

        this.current = `${this.ref.rangeFromInput.value.trim()}${this.ref.rangeToInput.value.trim()}`
    }
}